import React, { useEffect, useRef, useState } from "react";
import {
  DefaultButton,
  // Dialog,
  // DialogFooter,
  // DialogType,
  getTheme,
  // PrimaryButton,
  Stack,
} from "@fluentui/react";
// import {
//   Category,
//   EnhancedSearch,
//   ICategory,
//   IResult,
// } from "@coherence-design-system/enhanced-search";
// import { FeedbackCenter } from '@coherence-design-system/feedback-center';
import {
  Header,
  HeaderButton,
  // NotificationBadge,
  getTotalNewNotifications,
  usePanels,
  useResizeGroup,
} from "@coherence-design-system/header";
import {
  // INotificationBadgeProps,
  INotificationCategory,
  INotificationCenterProps,
  INotificationItem,
  NotificationCenter,
  NotificationStatus,
} from "@coherence-design-system/notification-center";
import { ProfileCenter } from "@coherence-design-system/profile-center";
import { Template } from "@coherence-design-system/slot";
import {
  // IComboBox,
  // IComboBoxOption,
  IContextualMenuProps,
  IPanel,
  ResizeGroup,
  Panel,
  Persona,
  PersonaSize,
  TooltipHost,
  // IContextualMenuItemProps,
} from "@fluentui/react";
import _ from "lodash";
import {
  IHeaderComponentProps,
  // INotificationBadgeProps,
  IProfile,
} from "./HeaderComponent.types";
import { useNavigate, useLocation } from "react-router-dom";
import { Providers, ProviderState } from "@microsoft/mgt-element";
import { ServiceEndpoints } from "../../config";
import axios from "axios";
import {
  LocalStorageContextDefaultValues,
  useLocalStorageContext,
} from "../../Provider/LocalStorageProvider";
import { EnhancedSearchComponent } from "../EnhancedSearchComponent/EnhancedSearchComponent";
import { getUserRoles } from "../../Utils/UserAuthorization";
import { appInsights } from "../../services/Logging/AppInsights";

const getCategorizedNotifications = (theme: any) => {
  return [];
};

export const HeaderComponent: React.FunctionComponent<IHeaderComponentProps> = (
  props
) => {
  const { isNavCollapsed, toggleNavCollapsed } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const theme = getTheme();
  const categorizedNotifications = getCategorizedNotifications(theme);

  const { setUser } = useLocalStorageContext();
  // const [activeScope, setActiveScope] = useState(DEFAULT_SCOPE);
  // const [searchText, setSearchText] = useState("");
  // const [searchingKey, setSearchingKey] = useState<string>("");

  const profileCenterRef = useRef<IPanel>(null);
  const notificationCenterRef = useRef<IPanel>(null);
  const feedbackCenterRef = useRef<IPanel>(null);
  const settingsPanelRef = useRef<IPanel>(null);
  const { currentPanel, openPanel, closePanel } = usePanels();
  const [profile, setProfile] = useState<IProfile>({
    userEmailId: "",
    userName: "",
    profileImage: "",
  });

  const showHamburger = true;

  useEffect(() => {
    Providers.globalProvider.graph.client
      .api("me")
      .get()
      .then((gotMe) => {
        setProfile({
          ...profile,
          userName: gotMe.displayName,
          userEmailId: gotMe.mail,
        });
      });
  }, []);

  // Profile Center
  const profileProps = {
    persona: {
      imageUrl:
        profile.profileImage ??
        "https://pbs.twimg.com/profile_images/497043545505947648/ESngUXG0.jpeg",
      text: profile.userName ?? "Celeste Burton",
      secondaryText: profile.userEmailId ?? "ceburton@microsoft.com",
      // secondaryText: "System administrator",
      // tertiaryText: profile.userEmailId ?? "ceburton@microsoft.com",
    },
    actions: [
      {
        children: "View account",
        onClick: () => {
          window.open("https://myaccount.microsoft.com/");
        },
      },
      {
        children: "Sign out",
        onClick: () => {
          setUser((previousUser) => ({
            ...previousUser,
            ...LocalStorageContextDefaultValues,
          }));
          localStorage.clear();
          Providers.globalProvider.setState(ProviderState.SignedOut);
          navigate("#");
        },
      },
    ],
  };

  // Notification Center
  const categoriesWithDeleteAllAction = categorizedNotifications.map(
    (category: INotificationCategory) => {
      category.deleteAllButton = {
        onClick: () =>
          setCategories((prevCategories) => {
            const updatedCategories: INotificationCategory[] = Object.assign(
              [],
              prevCategories
            );
            const matchingCategory = updatedCategories.find(
              (cat: INotificationCategory) => cat.title === category.title
            );

            if (matchingCategory) {
              matchingCategory.items = [];
            }

            return updatedCategories;
          }),
      };
      return category;
    }
  );

  const [categories, setCategories] = useState<INotificationCategory[]>(
    categoriesWithDeleteAllAction
  );

  const onOpenItem: INotificationCenterProps["onOpenNotificationItem"] = (
    item
  ) => {
    console.log("This notification item has been opened", item);
    onUpdateItem(item.itemKey, NotificationStatus.READ);
  };

  const onUpdateItem: INotificationCenterProps["onUpdateNotificationItem"] = (
    itemKey,
    displayStatus,
    readStatus
  ) => {
    setCategories((prevCategories) => {
      const updatedCategories: INotificationCategory[] = Object.assign(
        [],
        prevCategories
      );

      // Iterate through all categories until we find the item with the matching key, then update its status
      for (const category of updatedCategories) {
        const matchingItem = category.items.find(
          (item: INotificationItem) => item.itemKey === itemKey
        );
        if (matchingItem) {
          matchingItem.notificationStatus = displayStatus;
          matchingItem.status = readStatus;

          break;
        }
      }

      return updatedCategories;
    });
  };

  const markAllRead = () => {
    setCategories((prevCategories) => {
      return prevCategories.map((category) => {
        const newCat = Object.assign({}, category);
        newCat.items = newCat.items.map((item: INotificationItem) => {
          item.notificationStatus = "Read";
          return item;
        });

        return newCat;
      });
    });
  };

  const markAllUnread = () => {
    setCategories((prevCategories) => {
      return prevCategories.map((category) => {
        const newCat = Object.assign({}, category);
        newCat.items = newCat.items.map((item: INotificationItem) => {
          item.notificationStatus = "Unread";
          return item;
        });

        return newCat;
      });
    });
  };

  const deleteAll = () => {
    setCategories([]);
  };

  const panelActions: IContextualMenuProps = {
    items: [
      {
        key: "MARK_ALL_READ",
        text: "Mark all read",
        iconProps: { iconName: "Ringer" },
        onClick: () => markAllRead(),
      },
      {
        key: "MARK_ALL_UNREAD",
        text: "Mark all unread",
        iconProps: { iconName: "RingerSolid" },
        onClick: () => markAllUnread(),
      },
      {
        key: "SETTINGS",
        text: "Settings",
        iconProps: { iconName: "Settings" },
      },
      {
        key: "DELETE_ALL",
        text: "Delete all",
        iconProps: { iconName: "Delete" },
        onClick: () => deleteAll(),
      },
    ],
  };

  const numNewNotifications = getTotalNewNotifications(categories);

  const _items = [
    // {
    //   key: "notification",
    //   icon: "Ringer",
    //   ariaLabel: "Notification",
    //   text: "Notification", // Text will only render in the menuProps (overflow button dropdown); name will render both in the menuProps and in the regular HeaderButton, text to the icon
    //   onClick: () => {
    //     openPanel(notificationCenterRef);
    //   },
    //   checked: _.isEqual(currentPanel, notificationCenterRef),
    //   iconProps: { iconName: "Ringer" },
    //   onRenderIcon: (
    //     props: INotificationBadgeProps,
    //     defaultRender:
    //       | ((
    //           props?: IContextualMenuItemProps | undefined
    //         ) => JSX.Element | null)
    //       | undefined
    //   ) => (
    //     <NotificationBadge
    //       {...props}
    //       numNewNotifications={numNewNotifications}
    //       defaultRender={defaultRender}
    //     />
    //   ),
    // },
    {
      key: "settings",
      icon: "Settings",
      iconProps: {
        iconName: "Settings",
        styles: { root: { color: theme.palette.neutralPrimary } },
      },
      ariaLabel: "Settings",
      text: "Settings",
      checked: _.isEqual(currentPanel, settingsPanelRef),
      onClick: () => {
        openPanel(settingsPanelRef);
      },
      titleText: "Settings",
    },
    // {
    //   key: "feedback",
    //   icon: "Feedback",
    //   iconProps: { iconName: "Feedback" },
    //   ariaLabel: "Feedback",
    //   text: "Feedback",
    //   checked: _.isEqual(currentPanel, feedbackCenterRef),
    //   onClick: () => {
    //     openPanel(feedbackCenterRef);
    //   },
    // },
  ];

  const formattedData = {
    primary: _items,
    overflow: [],
  };
  const { onReduceData, onGrowData, onRenderData } = useResizeGroup({
    closePanel,
    currentPanel,
  });

  return (
    <>
      <Stack style={{ height: "48px", width: "100%", position: "fixed", zIndex: 1000 }} role="banner">
        <Header
          title="Commercial Assisted Sales Experience"
          showHamburger={showHamburger}
          toggleNavCollapsed={toggleNavCollapsed}
          isNavCollapsed={isNavCollapsed}
        >
          {location.pathname !== "/" && (
            <Template slot="search">
              <EnhancedSearchComponent />
            </Template>
          )}
          <Template slot="collapsible-triggers">
            <ResizeGroup
              styles={{ root: { background: "transparent", height: "100%" } }}
              data={formattedData}
              onReduceData={onReduceData}
              onGrowData={onGrowData}
              onRenderData={onRenderData}
            />
          </Template>
          <Template slot="static-triggers">
            <TooltipHost content={"profile"} id={"profile"}>
              <HeaderButton
                ariaLabel={"Profile"}
                onClick={() => openPanel(profileCenterRef)}
                checked={_.isEqual(currentPanel, profileCenterRef)}
                aria-describedby={"profile"}
              >
                <Persona
                  hidePersonaDetails={true}
                  size={PersonaSize.size28}
                  {...profileProps.persona}
                />
              </HeaderButton>
            </TooltipHost>
          </Template>
        </Header>
      </Stack>
      {/* Panels live outside the header. */}
      <>
        <NotificationCenter
          isOpen={Boolean(currentPanel === notificationCenterRef)}
          componentRef={notificationCenterRef}
          onDismiss={() => closePanel()}
          closeButtonAriaLabel={"Close"}
          categories={categories}
          onUpdateNotificationItem={onUpdateItem}
          panelActions={panelActions}
          onOpenNotificationItem={onOpenItem}
        />
        <Panel
          componentRef={profileCenterRef}
          isOpen={Boolean(currentPanel === profileCenterRef)}
          onDismiss={() => closePanel()}
          isLightDismiss={true}
          headerText="Profile"
          closeButtonAriaLabel="Close profile"
          // eslint-disable-next-line no-empty-function, @typescript-eslint/no-empty-function
          onOuterClick={(_e) => { }}
        >
          <Stack style={{ marginTop: "10px" }} tokens={{ childrenGap: 12 }}>
            <Persona
              imageUrl={profileProps.persona.imageUrl}
              text={profileProps.persona.text}
              secondaryText={profileProps.persona.secondaryText}
              size={PersonaSize.size72}
            />
            {profileProps.actions.map((action, index) => (
              <DefaultButton
                key={index}
                text={String(action.children)}
                onClick={action.onClick}
                styles={{ root: { marginTop: "8px" } }}
              />
            ))}
          </Stack>
        </Panel>
        {/* <FeedbackCenter
          componentRef={feedbackCenterRef}
          onDismiss={() => closePanel()}
          ocvOptions={ocvOptions}
          isOpen={Boolean(currentPanel === feedbackCenterRef)}
        /> */}
        <Panel
          componentRef={settingsPanelRef}
          onDismiss={closePanel}
          isOpen={Boolean(currentPanel === settingsPanelRef)}
          isLightDismiss={true}
          headerText="Settings"
          // We need to explicitly define this function so that isLightDismiss will bubble
          // the outer click event to other header buttons
          // eslint-disable-next-line no-empty-function, @typescript-eslint/no-empty-function
          onOuterClick={(_e) => { }}
        >
          <Stack style={{ marginTop: "5px" }}>
            <a
              href="https://go.microsoft.com/fwlink/?LinkId=521839"
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginTop: "5px", textDecoration: "none" }}
            >
              {" "}
              <h3 style={{ color: "rgb(0, 90, 158)" }}>Privacy Statement</h3>
            </a>
          </Stack>
        </Panel>
      </>
    </>
  );
};
